import { useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

type Crumb = {
  label: string;
  href: string;
};

const ROUTE_LABELS: Record<string, string> = {
  'system-requirements': 'Системные требования',
  terms: 'Пользовательское соглашение',
  privacy: 'Политика конфиденциальности',
  offer: 'Публичная оферта',
  cookies: 'Cookies',
  faq: 'FAQ',
  contacts: 'Контакты',
  security: 'Политика безопасности',
  refund: 'Возврат средств',
};

function humanizeSegment(segment: string): string {
  return ROUTE_LABELS[segment] ?? segment.replace(/-/g, ' ');
}

export default function Breadcrumbs() {
  const location = useLocation();

  const crumbs = useMemo<Crumb[]>(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    const result: Crumb[] = [{ label: 'Главная', href: '/' }];

    let acc = '';
    for (const part of parts) {
      acc += `/${part}`;
      result.push({ label: humanizeSegment(part), href: acc });
    }
    return result;
  }, [location.pathname]);

  useEffect(() => {
    // BreadcrumbList structured data
    const baseUrl = 'https://recvi.ru'; // прод-домен
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs.map((c, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        name: c.label,
        item: `${baseUrl}${c.href}`,
      })),
    };

    const id = 'jsonld-breadcrumbs';
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonLd);

    return () => {
      // keep script; content will update on route change
    };
  }, [crumbs]);

  if (crumbs.length <= 1) return null;

  return (
    <nav className="breadcrumbs" aria-label="Хлебные крошки">
      <ol className="breadcrumbs-list">
        {crumbs.map((c, idx) => {
          const isLast = idx === crumbs.length - 1;
          return (
            <li key={c.href} className="breadcrumbs-item">
              {isLast ? (
                <span className="breadcrumbs-current" aria-current="page">
                  {c.label}
                </span>
              ) : (
                <Link to={c.href} className="breadcrumbs-link">
                  {c.label}
                </Link>
              )}
              {!isLast && <span className="breadcrumbs-sep">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

